export namespace InputsNS {
  export interface Assistive {
    message: string;
    type?: StatusType;
  }

  export type AssistiveType = [Assistive] | [Assistive, Assistive];

  export enum StatusType {
    Error = 'error',
    Warning = 'warning',
    Informative = 'informative',
    Success = 'success',
    Disabled = 'disabled',
  }

  export interface SelectOption<T extends string | number = string> {
    /**
     * The id of the option.
     * @required
     */
    id: string;
    /**
     * The name of the option.
     * @required
     */
    name: string;
    /**
     * The value of the option.
     * @required
     */
    value: T;
    /**
     * The label of the option.
     * @required
     */
    label: string;
    /**
     * Whether the option is disabled.
     * @default false
     */
    disabled?: boolean;
    /**
     * Whether the option is selected.
     * @default false
     */
    selected?: boolean;
  }
}
